import React from 'react'

import PresenterPreview from './PresenterPreview'
import ClientNameInput from './ClientNameInput'

const CustomizeAdvisor = props => {
  const { rigUrl } = props.content

  return (
    <div className='setup-form-wrapper u-flexJustifyBetween u-flex u-marginBottom12gu u-sizeConstrained'>
      <PresenterPreview />
      <ClientNameInput welcomeUrl={rigUrl} />
    </div>
  )
}

export default CustomizeAdvisor
